export enum PageTypeEnum {
    Accommodation = 'accommodation',
    City = 'city',
    CityCategory = 'cityCategory',
    CityPictogram = 'cityPictogram',
    CityPictogramCategory = 'cityPictogramCategory',
    CitySpecialOffer = 'citySpecialOffer',
    CityService = 'cityService',
    CityCenter = 'cityCenter',
    CityCenterCategory = 'cityCenterCategory',
    CityCheapAccommodation = 'cityCheapAccommodation',
    CityCategoryCheapAccommodation = 'cityCategoryCheapAccommodation',
    CityOpinions = 'cityOpinions',
    Region = 'region',
    RegionCategory = 'regionCategory',
    RegionPictogram = 'regionPictogram',
    RegionPictogramCategory = 'regionPictogramCategory',
    RegionCheapAccommodation = 'regionCheapAccommodation',
    RegionSpecialOfferPage = 'regionSpecialOfferPage',
    RegionSpecialOffer = 'regionSpecialOffer',
    Voivodeship = 'voivodeship',
    VoivodeshipCategory = 'voivodeshipCategory',
    VoivodeshipCenterCategory = 'voivodeshipCenterCategory',
    VoivodeshipSpecialOffer = 'voivodeshipSpecialOffer',
    VoivodeshipSpecialOfferPage = 'voivodeshipSpecialOfferPage',
    VoivodeshipService = 'voivodeshipService',
    VoivodeshipOpinion = 'voivodeshipOpinion',
    VoivodeshipCenter = 'voivodeshipCenter',
    VoivodeshipCheapAccommodation = 'voivodeshipCheapAccommodation',
    VoivodeshipCategoryPage = 'voivodeshipCategoryPage',
    VoivodeshipPictogram = 'voivodeshipPictogram',
    VoivodeshipPictogramCategory = 'voivodeshipPictogramCategory',
    Country = 'country',
    CountryCategory = 'countryCategory',
    CountrySpecialOffer = 'countrySpecialOffer',
    CountryCheapAccommodation = 'countryCheapAccommodation',
    CountryCategoryCheapAccommodation = 'countryCategoryCheapAccommodation',
    CountryPictogram = 'countryPictogram',
    CountryService = 'countryService',
    CountrySpecialOfferPage = 'countrySpecialOfferPage',
}
